"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.GtmConsentWrapper = GtmConsentWrapper;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const gtm_1 = require("./gtm");
function GtmConsentWrapper({ gtmId, gfiberGtmId, environment, buildLabel, nonce, forceBlockList = false, }) {
    const [dataLayer, setDataLayer] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        // Note: Privacy consent updates in marketing/portal always trigger a full page reload,
        // so reading localStorage once on mount is sufficient.
        let consent = null;
        try {
            consent = window.localStorage.getItem('user_privacy_consent');
        }
        catch {
            // Fallback to blocking if localStorage is inaccessible
        }
        const useBlockList = forceBlockList || consent === 'DENIED';
        setDataLayer({
            environment,
            buildLabel,
            ...(useBlockList && {
                'gtm.blocklist': [
                    'customPixels',
                    'nonGooglePixels',
                    'customScripts',
                    'nonGoogleScripts',
                    'nonGoogleTags',
                ],
            }),
        });
    }, [environment, buildLabel, forceBlockList]);
    if (!dataLayer) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(gtm_1.GoogleTagManager, { gtmId: gtmId, gfiberGtmId: gfiberGtmId, dataLayer: dataLayer, dataLayerName: "dataLayer", nonce: nonce }));
}
